import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs-compat";

@Component({
    selector: "ngx-blog",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./blog.component.scss"],
})
export class BlogLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
